import { staff } from '../../api/staff';
import { IframeWindow } from '.';
import { BaseRequest } from 'api';

export class Staff implements staff.Api {
  constructor(private iframe: IframeWindow) {}

  selectStaff(request?: staff.SelectStaffRequest): Promise<staff.Staff[]> {
    return this.iframe.twoWayCall<BaseRequest, staff.Staff[]>(
      request,
      (requestId, request) => {
        this.iframe.postMessage({
          command: 'staff.selectStaff',
          args: {
            ...request,
            requestId,
          },
        });
      },
      (response) => {
        return response;
      }
    );
  }

  //   getLists(request: BaseRequest): Promise<staff.Staff[]> {
  //     return this.iframe.twoWayCall<BaseRequest, staff.Staff[]>(
  //       request,
  //       (requestId, request) => {
  //         this.iframe.postMessage({
  //           command: 'staff.getLists',
  //           args: {
  //             ...request,
  //             requestId,
  //           },
  //         });
  //       },
  //       (response) => {
  //         let responseData;
  //         try {
  //           responseData = JSON.parse(response);
  //         } catch (e) {
  //           // Unable to parse response => response is not a stringify object
  //           responseData = response;
  //         }
  //         return responseData;
  //       }
  //     );
  //   }
}
